import {birthDateValidator} from '../../../utils';
import {getNextPartnerQuestion} from '../flowPartners/flowPartners';

export const informPartnerBd = (inputValue) => {
  const valueMessage = inputValue.replace(/\//g, '-');
  return birthDateValidator(valueMessage);
};

export const setPartnerBirthDate = (
  ecState,
  partnerSel,
  partnerVd,
  partnerBd,
  idQuestion,
  quizPartners,
  partnersTypeList
) => {
  let partners = ecState.partners.map((partner) => {
    if (partner.id === partnerSel.id) {
      return {
        ...partner,
        birthDate: partnerVd.partnerBd
      };
    }
    return partner;
  });

  let nextQuestion = getNextPartnerQuestion(
    idQuestion,
    quizPartners,
    partners,
    partnerSel,
    partnersTypeList
  );

  let messages = [
    {
      text: partnerBd,
      edit: 'birth-date-partner',
      type: 'response-sent'
    }
  ];

  messages.push(...nextQuestion.messages);

  return {
    messages,
    partners,
    partnerBd,
    nextPartner: nextQuestion.partner,
    changePartner: nextQuestion.nextPartner,
    responseType: nextQuestion.responseTypeChange,
    partnersComplete: nextQuestion.partnersComplete,
    partnersTypeList: nextQuestion.partnersTypeList
  };
};
